import React from 'react'
import s from './InlineDesktopAdBanner.less'
import classnames from 'classnames'
import { withOnlyGE } from '../Device'
import AdLoader from './AdLoader'
import { useSelector } from 'react-redux'
import { selectCurrentHistoryRoute } from '../../store/history/history.selectors'
import { selectAddressKeywords, selectGeoentityAdsKeywords, selectItineraryKeywords } from '../../store/ad/ad.selectors'
import { ROUTE_ITINERARY_ROADBOOK } from '../../routes'

const InlineDesktopAdBanner = withOnlyGE(({ adName, keywordsSelector, className }) => (
  <div className={classnames(s.container, className)}>
    <AdLoader adName={adName} keywordsSelector={keywordsSelector} className={s.content} />
  </div>
))

export const AdDesktopBannerHP = () => <InlineDesktopAdBanner adName="hp_banner_desktop" />

export const AdDesktopAddressHP = () => (
  <InlineDesktopAdBanner adName="address_rectangle_desktop" keywordsSelector={selectAddressKeywords} />
)

export const AdDesktopItineraryHP = () => <InlineDesktopAdBanner adName="hp_itinerary_banner_desktop" />

export const AdDesktopRectangleItineraryResult = () => {
  const route = useSelector(selectCurrentHistoryRoute)
  const adName =
    route === ROUTE_ITINERARY_ROADBOOK
      ? 'roadbook_routelist_rectangle_desktop'
      : 'itinerary_routelist_rectangle_desktop'

  return (
    <InlineDesktopAdBanner
      adName={adName}
      className={s.AdDesktopRectangleItineraryResult}
      keywordsSelector={selectItineraryKeywords}
    />
  )
}

export const AdDesktopExpenseReport = () => (
  <InlineDesktopAdBanner adName="expense_report_banner" keywordsSelector={selectItineraryKeywords} />
)

export const AdDesktopRectangleGeoentity = () => (
  <InlineDesktopAdBanner adName="poi_rectangle_desktop" keywordsSelector={selectGeoentityAdsKeywords} />
)
